function unsetQuery(filters, qry) {
  const { fieldName, operator } = qry;
  if (filters[fieldName] && filters[fieldName][operator]) {
    delete filters[fieldName][operator];
  }
}
export default unsetQuery;
